import { Injectable } from '@angular/core';
import { ModalType } from '../../core/helpers/modal-type';
import { startWith } from 'rxjs-compat/operator/startWith';
import { CinetykApiService } from './cinetyk-api.service';
import { Produttore } from '../models/produttore';
import { Indirizzo } from '../models/indirizzo';
import { Prodotto } from '../models/prodotto';
import { Router } from '@angular/router';
import { LayoutComponent } from '../../admin/layout/layout.component';
import { Categoria } from '../models/categoria';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

public modalType: ModalType;
public args: string[];
public layout: LayoutComponent;
  constructor(private cinetykApiService: CinetykApiService, private router: Router) { }

  public deleteYesClick(){
     switch(this.modalType){
      case ModalType.produttore:
        this.produttoreDeleteYesClick(this.args);
        break;
      case ModalType.prodotto:
        this.prodottoYesClick(this.args);
        break;
      case ModalType.categoria:
        this.categoriaDeleteYesClick(this.args);
        break;
     }
  }




  prodottoYesClick(args: string[]){
    if(args.length>0)
    {
      this.cinetykApiService.getProdottoById(+args[0]).subscribe((data:Prodotto)=>{
        this.cinetykApiService.deleteProdotto(data).subscribe((data:any)=>{
          this.router.navigate(['/admin/prodotti/lista']);
          this.layout.closeDeleteModal();
        });
      })
    }
  }

  produttoreDeleteYesClick(args: string[]){
    if(args.length>0)
    {
      this.cinetykApiService.getProduttoreById(+args[0]).subscribe((data:Produttore)=>{  
        let idIndirizzo = +data.indirizzo[0].split('/')[data.indirizzo[0].split('/').length-1];
        this.cinetykApiService.getIndirizzoById(idIndirizzo).subscribe((dataIndirizzo:Indirizzo)=>{      
          this.cinetykApiService.deleteIndirizzo(dataIndirizzo).subscribe((dataDeletedIndirizzo:any)=>{
            this.cinetykApiService.deleteProduttore(data).subscribe(dataDeletedProduttore=>{
              this.router.navigate(['/admin/produttori/lista']);
            })
          });
        });
      });
    }

  }

  categoriaDeleteYesClick(args: string[]){
    if(args.length>0)
    {
      this.cinetykApiService.getCategoriaById(+args[0]).subscribe((data:Categoria)=>{
        this.cinetykApiService.deleteCategoria(data).subscribe((data:any)=>{
          this.router.navigate(['/admin/categorie/lista']);
          this.layout.closeDeleteModal();
        });
      })
    }
  }
}
